import { Close } from '@mui/icons-material';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Stack } from '@mui/material';
import { SxProps } from '@mui/system';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CAppPaper from '../../../../app/components/CAppPaper';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import useDocumentTypeSubs from '../../../document/hooks/useDocumentTypeSubs';
import langDocumentNotification from '../../../document/langs/langDocumentNotification';
import { langLookup } from '../../../../app/utils/langLookup';
import useUserProfile from '../../hooks/useUserProfile';
import useUserUpdateNotifications from '../../hooks/useUserUpdateNotifications';
import langUserProfile from '../../langs/langUserProfile';
type VUserProfileNotificationsProps = {
	sxStyle: SxProps;
	sxEditButton: SxProps;
	disableEdit: boolean;
};
const VUserProfileNotifications = (props: VUserProfileNotificationsProps) => {
	const { sxStyle, sxEditButton, disableEdit } = props;

	const [editBlock, setEditBlock] = useState(false);

	const { documentTypeSubs } = useDocumentTypeSubs();
	const { t } = useTranslation();

	const [notificationTags, setNotificationTags] = useState<(string | null)[] | null>(null);
	useEffect(() => {
		if (documentTypeSubs) {
			setNotificationTags(_.uniq(documentTypeSubs.filter((x) => x.emailTag !== null).map((x) => x.emailTag)));
		}
	}, [documentTypeSubs]);

	const { investorProfile } = useUserProfile();
	const { mutate: updateNotifications } = useUserUpdateNotifications();

	const handleClickEditNotifications = () => {
		setEditBlock(!editBlock);
	};

	const [selectedNotificationTags, setSelectedNotificationTags] = useState<string[] | null>(null);
	useEffect(() => {
		if (investorProfile) {
			setSelectedNotificationTags(investorProfile.notificationTags ?? null);
		}
	}, [investorProfile]);

	const handleClickSaveNotifications = () => {
		updateNotifications(selectedNotificationTags ?? [], {
			onSuccess: () => {
				setEditBlock(!editBlock);
			},
		});
	};

	const handleClickOnTag = (notificationTag: string) => {
		const selectedNotificationTagsTmp = _.clone(selectedNotificationTags) ?? [];
		const index = selectedNotificationTagsTmp.findIndex((x) => x === notificationTag);
		if (index < 0) {
			selectedNotificationTagsTmp.push(notificationTag);
		} else {
			selectedNotificationTagsTmp.splice(index, 1);
		}
		setSelectedNotificationTags(selectedNotificationTagsTmp);
	};

	return (
		<CAppPaper sx={sxStyle} variant="outlined">
			<Stack direction="row" alignItems="center" justifyContent="space-between">
				<Box className="title">
					<AppCustomIcon tag="user_notifications" className="icon" />{' '}
					{t(langUserProfile.title_notifications.tag)}
				</Box>
				<Box>
					{editBlock ? (
						<>
							<Button
								variant="text"
								color="secondary"
								size="small"
								sx={{ ...sxEditButton, marginRight: '20px' }}
								type="button"
								startIcon={<Close />}
								onClick={() => handleClickEditNotifications()}
							>
								{t(langUserProfile.btn_cancel.tag)}
							</Button>
							<Button
								variant="contained"
								color="secondary"
								id="btn-save-settings"
								size="small"
								sx={sxEditButton}
								disabled={disableEdit}
								startIcon={<AppCustomIcon tag="save" className="icon" />}
								onClick={() => handleClickSaveNotifications()}
							>
								{t(langUserProfile.btn_save.tag)}
							</Button>
						</>
					) : (
						<Button
							variant="text"
							color="secondary"
							id="btn-edit-settings"
							size="small"
							sx={sxEditButton}
							disabled={disableEdit}
							startIcon={<AppCustomIcon tag="edit" className="icon" />}
							onClick={() => handleClickEditNotifications()}
						>
							{t(langUserProfile.btn_edit.tag)}
						</Button>
					)}
				</Box>
			</Stack>
			{editBlock ? (
				<Box sx={{ marginTop: '20px' }}>
					{notificationTags && selectedNotificationTags ? (
						<FormGroup>
							{notificationTags.map((notificationTag) => {
								return (
									<Box key={notificationTag}>
										<FormControlLabel
											control={
												<Checkbox
													checked={selectedNotificationTags.includes(
														notificationTag as string,
													)}
													onChange={() => handleClickOnTag(notificationTag as string)}
												/>
											}
											label={
												langLookup(langDocumentNotification, notificationTag as string)
													? t(
															langLookup(
																langDocumentNotification,
																notificationTag as string,
															)?.tag ?? '',
													  )
													: notificationTag
											}
										/>
									</Box>
								);
							})}
						</FormGroup>
					) : (
						<></>
					)}
				</Box>
			) : (
				<Box sx={{ marginTop: '20px' }}>
					<Trans
						t={t}
						i18nKey={langUserProfile.label_for_block_notifications.tag}
						values={{
							nbNotifications: investorProfile?.notificationTags?.length ?? 0,
							nbNotificationsTotal: notificationTags ? notificationTags.length : '',
						}}
					/>
				</Box>
			)}
		</CAppPaper>
	);
};

export default VUserProfileNotifications;
